<template>
    <!--<section id="comments" class="min-h-screen">-->
    <section id="comments">
        <div class="bg-white dark:bg-slate-800 shadow lg:rounded-t-lg">
            <!-- Comments -->
            <div class="divide-gray-200 dark:divide-slate-900 divide-y">
                <transition enter-active-class="ease-out duration-300" enter-class="opacity-0" enter-to-class="opacity-100" leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
                    <div v-show="comments.length" class="px-4 py-0">
                        <ul id="post-comments" class="grid grid-cols-1 divide-gray-200 dark:divide-slate-900 divide-y" role="list">
                            <li v-for="comment in comments" :id="'comment-' + comment.id" class="py-3" role="listitem">
                                <div class="flex items-start space-x-3">
                                    <avatar :user="comment.user" class="flex-shrink-0 w-9 h-9" />
                                    <div class="flex flex-col">
                                        <div class="text-sm">
                                            <a class="text-gray-900 dark:text-slate-400" href="#" @click.prevent>{{ comment.user.tag }}</a>
                                            <span class="text-gray-600 dark:text-slate-300" v-html="comment.body"></span>
                                        </div>
                                        <div class="flex items-center text-gray-500 text-sm leading-5 space-x-2">
                                            <like :likeable="comment"></like>
                                            <!--                                            <span aria-hidden="true">·</span>-->
                                            <!--                                            <a href="#" class="hover:text-indigo-500">Reply</a>-->
                                            <span aria-hidden="true" class="text-gray-500 dark:text-slate-400 font-medium">·</span>
                                            <div class="has-tooltip cursor-default dark:text-slate-400">
                                                <time :datetime="comment.createdAt">
                                                    {{ comment.createdAt | when }}
                                                </time>
                                                <tooltip>{{ formatDate(comment.createdAt, "lll") }}</tooltip>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>
        </div>

        <div class="sticky z-40 bottom-0 inset-x-0 col-span-6 col-start-4 bg-gray-100 dark:bg-slate-800 overflow-hidden">
            <comment-form ref="commentForm" :post="post" />
        </div>

        <delete-comment-modal></delete-comment-modal>
    </section>
</template>

<script>
import JetInputError from "@/Jetstream/InputError"
import JetActionMessage from "@/Jetstream/ActionMessage"
import JetConfirmationModal from "@/Jetstream/ConfirmationModal"
import JetSecondaryButton from "@/Jetstream/SecondaryButton"
import JetDangerButton from "@/Jetstream/DangerButton"
import Like from "@/Components/Like"
import DeleteCommentModal from "@/Comments/DeleteCommentModal"
import JetDropdown from "@/Jetstream/Dropdown"
import JetButton from "@/Jetstream/Button"
import AlertWarning from "@/Components/Alerts/Warning"
import Tooltip from "@/Components/Tooltip"
import CommentForm from "@/Comments/CommentForm"

export default {
    name: "Comments",

    components: {
        CommentForm,
        Tooltip,
        AlertWarning,
        JetButton,
        JetDropdown,
        JetDangerButton,
        JetSecondaryButton,
        JetConfirmationModal,
        JetInputError,
        JetActionMessage,
        Like,
        DeleteCommentModal,
    },

    mounted() {
        const commentFormTop = new IntersectionObserver(
            ([e]) =>
                _.each(["shadow-none", "sm:rounded-t-lg"], function (cl) {
                    e.target.classList.toggle(cl, e.intersectionRatio < 1)
                }),
            { rootMargin: "-1px 0px 0px 0px", threshold: [1] }
        )

        commentFormTop.observe(this.$refs.commentForm.$el)
    },

    props: {
        post: {
            default: null,
            type: Object,
        },
    },

    computed: {
        comments() {
            if (!this.post) return null
            return this.post.comments
        },

        commentCount() {
            if (!this.comments) return 0
            return this.comments.length
        },
    },

    watch: {},

    data() {
        return {
            deleteCommentForm: this.$inertia.form({}),
            LikeCommentForm: this.$inertia.form({}),
            commentBeingDeleted: null,
            reportingComment: null,
        }
    },

    methods: {
        confirmReportComment(comment) {
            this.reportingComment = comment
        },

        confirmDeleteComment(comment) {
            this.commentBeingDeleted = comment
        },

        deleteComment() {
            this.deleteCommentForm.delete(this.commentBeingDeleted.delete_url, {
                errorBag: "deleteComment",
                preserveScroll: true,
                onSuccess: () => (this.commentBeingDeleted = null),
            })
        },

        LikeComment(comment) {
            this.LikeCommentForm.post(comment.Like_url, {
                errorBag: "LikeComment",
                preserveScroll: true,
            })
        },

        recentLikes(comment) {
            return _.take(comment.Likes, 4)
        },
    },
}
</script>
